import { render, staticRenderFns } from "./testimonial-card.vue?vue&type=template&id=21eb8a1a"
import script from "./testimonial-card.vue?vue&type=script&lang=js"
export * from "./testimonial-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports